import React from 'react';
import { StatsigProvider } from '@statsig/react-bindings';
import { useAuth } from '../../hooks';
import { isEmpty } from 'lodash-es';

const statSigEnvironment = process.env.REACT_APP_STATSIG_TIER as
  | 'production'
  | 'staging'
  | 'development'
  | 'qa'
  | undefined;

export function StatSigProvider({ children }: { children: React.ReactNode | React.ReactNode[] }): JSX.Element {
  if (isEmpty(process.env.REACT_APP_STATSIG_SECRET_KEY)) {
    return children as React.ReactNode | React.ReactNode[] as JSX.Element;
  }

  return <StatSigProviderWrapper>{children}</StatSigProviderWrapper>;
}

function StatSigProviderWrapper({ children }: { children: React.ReactNode | React.ReactNode[] }): JSX.Element {
  const { currentUser } = useAuth();

  return (
    <StatsigProvider
      sdkKey={process.env.REACT_APP_STATSIG_SECRET_KEY as string}
      user={{ userID: currentUser?.email }}
      options={{ environment: { tier: statSigEnvironment } }}
    >
      {children}
    </StatsigProvider>
  );
}
